class Size {
    constructor(width, height) {
        this.width = width;
        this.height = height;
    }
    static Empty() {
        return new Size(0, 0);
    }
}
export { Size };
